@import (reference) '../../../../constants/spacing.module.less';

.rate-card {
  gap: @space-8;
  padding: @space-16;
  border-radius: @space-16 @space-16 @space-0 @space-0;
  box-shadow: 0 -4px 2px -2px var(--dark--box-shadow-color--1);
}

.primary-content {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  gap: @space-8;
}

.buttons {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: @space-8;
}

.expander-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.expander-button {
  height: 32px;
  width: 32px;
  color: var(--light--button--fill-color--1);
  padding: @space-8;

  &:focus-visible {
    background: var(--default--background-color--16);

    outline: solid 1px var(--primary--focus--border-color--3);
    outline-offset: -1px;
  }

  &:enabled {
    &:hover {
      background: var(--default--background-color-17);
    }

    &:active {
      background: var(--default--background-color--15);
    }
  }
}

.no-charge-banner {
  width: 100%;
  height: @space-28;
}

.no-charge-banner-container {
  justify-content: flex-start;
}

.no-charge-text {
  color: var(--info--text-color--1);
}
